import styled from 'styled-components';
import React from 'react';
import createVariantSelector from '../theme/helpers/create-variant-selector';

type TagSize = 'small' | 'medium';

interface VariantProps {
  size?: TagSize;
}

const variantSize = createVariantSelector<VariantProps>('size', [
  'small',
  'medium',
]);

export interface TagProps extends VariantProps {
  text?: string;
}

function Tag({ text, size = 'medium' }: TagProps) {
  return <TagCss size={size}>{text}</TagCss>;
}

const TagCss = styled.div<VariantProps>`
  ${p => p.theme.getFontStyle('primary', 'semiBold')}
  font-size: ${variantSize('typography', ['textXxxs', 'textBase'])};
  background-color: ${p => p.theme.tag.bgColor};
  border-radius: ${variantSize('sizes', ['borderRadiusXs', 'borderRadiusSm2'])};
  color: ${p => p.theme.tag.textColor};
  text-transform: uppercase;
  display: inline-flex;
  padding: 0.15em 0.4em 0.1em;
  white-space: nowrap;
`;

export default Tag;
